// services/api/profiles.ts
import { TProfile, TProfilesFilters } from '../../../types';
import { baseApi } from './baseApi';

export const profilesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfiles: builder.query<
      { profiles: TProfile[] },
      { page?: number; code?: number } & TProfilesFilters
    >({
      query: (body) => ({
        url: '/profiles',
        method: 'POST',
        body,
      }),
      providesTags: ['Profiles'],
    }),


    getProfilesCount: builder.query<
      { count: number },
      TProfilesFilters
    >({
      query: (filters) => ({
        url: '/profiles/count',
        method: 'POST',
        body: filters, // если POST-запрос
      }),
      // Кэшируем на 30 секунд — достаточно для превью
      keepUnusedDataFor: 30,
      // Не блокируем UI при рефетче
      forceRefetch: ({ currentArg, previousArg }) => {
        return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
      },
    }),

    sendProfileAction: builder.mutation<
      any,
      { profileId: number; actionType: string }
    >({
      query: ({ profileId, actionType }) => ({
        url: `/profiles/${profileId}/${actionType}`,
        method: 'POST',
        body: {},
      }),
      invalidatesTags: ['Profiles', 'Match', 'User', 'Events'],
    }),
  }),
});

export const {
  useGetProfilesQuery,
  useGetProfilesCountQuery,
  useSendProfileActionMutation,
} = profilesApi;
